// Set the way a photo's camera faced by hand: eight points and Clear.
import { DIRECTIONS, type Direction } from '../lib/compass';

interface Props {
  value: Direction | null;
  onPick: (direction: Direction | null) => void;
  onClose: () => void;
}

export function DirectionPicker({ value, onPick, onClose }: Props) {
  return (
    <div role="dialog" aria-label="Camera facing" className="absolute left-0 top-full z-10 mt-1 w-44 rounded-lg border border-slate-200 bg-white p-2 shadow-lg">
      <p className="mb-1 text-xs text-slate-600">Camera facing</p>
      <div className="grid grid-cols-4 gap-1">
        {DIRECTIONS.map((d) => (
          <button
            key={d}
            type="button"
            onClick={() => onPick(d)}
            className={`h-9 rounded text-sm ${d === value ? 'bg-primary text-primary-foreground' : 'bg-slate-100 text-slate-800'}`}
          >
            {d}
          </button>
        ))}
      </div>
      <div className="mt-2 flex justify-between text-xs">
        <button type="button" onClick={() => onPick(null)} className="h-8 px-1 text-slate-600 underline">
          Clear
        </button>
        <button type="button" onClick={onClose} className="h-8 px-1 text-primary">
          Done
        </button>
      </div>
    </div>
  );
}
